import Masonry from 'masonry-layout';
import tailSelect from '../vendor/tail.select';
import helpers from './helpers.js';

/*
===================================================================
Profiles
===================================================================
*/
export default (function () {
  let msnry;
  return {
    init() {
      const filterProfiles = document.querySelector('.js-filter-profiles');
      if (filterProfiles) {
        this.filterProfiles(filterProfiles);
      }

      this.buildLayout();
    },
    buildLayout() {
      const profileGrids = document.querySelectorAll('.profiles');
      if (profileGrids != null && profileGrids.length) {
        [...profileGrids].forEach((profileGrid, i) => {
          msnry = new Masonry(profileGrid, {
            gutter: 20,
            transitionDuration: '0.3s',
            columnWidth: 33.333,
          });

          profileGrid.addEventListener('click', (e) => {
            if (e.target.matches('.js-expand-link')) {
              msnry.layout();
            }
          });
        });
      }
    },
    filterProfiles(filterProfiles) {
      const filterSelect = document.querySelector('.js-profile-filter-select');
      if (filterSelect) {
        console.log(filterSelect);

        const multiContainer = filterSelect.getAttribute('data-container');
        const options = {
          multiShowCount: false,
          sourceBind: true,
          multiContainer,
        };
        tailSelect(filterSelect, options);

        filterSelect.addEventListener('change', (e) => {
          if (e.detail === null) {
            this.toggleProfiles(filterProfiles, []);
          } else {
            const { self } = e.detail;
            this.toggleProfiles(filterProfiles, self.options.selected);
          }
        });
      }
    },
    toggleProfiles(filterProfiles, selectedItems) {
      const profiles = filterProfiles.querySelectorAll('.profile');

      if (selectedItems.length <= 0) {
        [...profiles].forEach((p, i) => {
          helpers.removeClass(p, 'u-hide');
          helpers.removeClass(p, 'is-hidden');
        });
        this.rebuildLayout();
        return;
      }


      [...profiles].forEach((p, i) => {
        const { filters } = p.dataset;
        helpers.removeClass(p, 'u-hide');
        helpers.removeClass(p, 'is-hidden');

        const filtersObj = JSON.parse(filters);

        let hasfilter = false;
        selectedItems.forEach((selectedItem) => {
          const { label } = selectedItem;
          filtersObj.forEach((f) => {
            if (f === label) {
              hasfilter = true;
            }
          });
        });

        if (!hasfilter) {
          helpers.addClass(p, 'u-hide');
          helpers.addClass(p, 'is-hidden');
        }
      });

      this.rebuildLayout();
    },
    rebuildLayout() {
      msnry.destroy();
      this.buildLayout();
    },
  };
}());
